import { PaymentType, PayPortionState } from '../shared/enums/smarthub-enums';

export class ActionHistory {

  static fromRawEvent(rawEvent: any): ActionHistory {
    return new this(
      rawEvent.aggId,
      rawEvent.details.employeeName,
      rawEvent.details.employeeNumber,
      rawEvent.details.amount,
      rawEvent.details.appliedAction.bankReasonCode,
      rawEvent.details.appliedAction.action.fromState,
      rawEvent.details.appliedAction.action.toState,
      rawEvent.user,
      rawEvent.details.appliedAction.itemNo,
      rawEvent.details.payUtcDate,
      rawEvent.details.appliedAction.actionUtcDateTime,
      rawEvent.details.appliedAction.portion,
      rawEvent.details.text,
      rawEvent.details.appliedAction.action.isUndo,
      rawEvent.details.referenceNumber
    );
  }

  constructor(
    public aggId: string,
    public employeeName: string,
    public employeeNumber: string,
    public amount: string,
    public bankReasonCode: string,
    public fromState: PayPortionState,
    public toState: PayPortionState,
    public user: string,
    public itemNo: string,
    public payUtcDate: string,
    public actionUtcDateTime: string,
    public portion: PaymentType,
    public text: string,
    public isUndo: boolean,
    public referenceNumber: string
  ) {}

  get toStateKey(): string {
    return this._getStateKey(this.toState);
  }

  get fromStateKey(): string {
    return this._getStateKey(this.fromState);
  }

  private _getStateKey(state: PayPortionState): string {
    switch (state) {
      case PayPortionState.CanceledAfterPaid:
      case PayPortionState.CanceledBeforePaid:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_CANCELED';
      case PayPortionState.CancellationRequested:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_PAY_STOP_REQUESTED';
      case PayPortionState.Unmodified:
        return 'EMPLOYEE_PAYS.UNDONE';
      default:
        return 'EMPLOYEE_PAYS.PAY_ITEM_STATUS_UNKOWN';
    }
  }
}
